module.exports = "//static.hsappstatic.net/connect-dot-com-ui-components/static-1.428/images/logo/connect-dot-com-icon.svg"